import {useState, useEffect, useContext} from 'react';
import {ReactReduxContext} from 'react-redux';
import wrap from 'wraptile';

interface OnEffectProps {
    subscribe: (v: () => void) => void;
    setStoreState: (v: void) => void;
    getState: () => void;
}

export const onSetStoreState = wrap((setStoreState: (v: void) => void, getState: () => void) => {
    setStoreState(getState());
});

export const onEffect = wrap(({subscribe, setStoreState, getState}: OnEffectProps) => {
    return subscribe(onSetStoreState(setStoreState, getState));
});

const useStore = () => {
    const {store} = useContext(ReactReduxContext);
    const {getState, dispatch, subscribe} = store;
    const [storeState, setStoreState] = useState(getState());
    const onSubscribe = onEffect({
        subscribe,
        setStoreState,
        getState,
    });
    
    useEffect(onSubscribe, []);
    
    return [storeState, dispatch];
};

export default useStore;
